import { InstalledSoftware } from "@/model/data/InstalledSoftware";
import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { IPaginationFilter } from "../supportObjects/IPaginationFilter";
import { GetConfigurationTemplateResData } from "./GetConfigurationTemplateResData";
import { IsNamedSoftwareVersion, NamedSoftwareVersion } from "@/model/data/updates/NamedSoftwareVersion";
import { UpdateTypeEnum } from "@/model/data/enums/UpdateTypeEnum";

const ENDPOINT = "/caosconfiguration/template";

export class GetConfigurationTemplateCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: GetConfigurationTemplateReqData;

    constructor(payload: GetConfigurationTemplateReqData) {
        super();
        this.payload = payload;
    }

    public async execute(): Promise<GetConfigurationTemplateResData> {
        let res = await this.executeCommand(this.payload);
        return new GetConfigurationTemplateResData(res);
    }
}

export class GetConfigurationTemplateReqData implements IPaginationFilter {
    // PaginationFilters
    queryLimit: number = 0;
    offset: number = 0;
    orderBy: string[] = null;
    orderByDescending: boolean[] = null;

    softwareVersionFilterList: InstalledSoftware[] = [];

    constructor(obj: any) {
        if (obj.queryLimit) this.queryLimit = obj.queryLimit;
        if (obj.offset) this.offset = obj.offset;
        if (obj.orderBy) this.orderBy = obj.orderBy;
        if (obj.orderByDescending) this.orderByDescending = obj.orderByDescending;
    }
}

export function CreateGetConfigurationTemplateReqData(req: GetConfigurationTemplateReqData): GetConfigurationTemplateReqData {
    let softwareVersionFilterList: InstalledSoftware[] = [];
    let reqProps = Object.keys(req);

    reqProps.forEach((prop) => {
        if (Array.isArray(req[prop]) && IsNamedSoftwareVersion(req[prop][0])) {
            req[prop].forEach((softwareFilter: NamedSoftwareVersion) => {
                let sw = new InstalledSoftware();

                if (Object.keys(UpdateTypeEnum).includes(softwareFilter.name)) sw.updateType = UpdateTypeEnum[softwareFilter.name];
                else sw.updateType = UpdateTypeEnum.ThirdPartySoftware;

                sw.name = softwareFilter.name;
                sw.version = softwareFilter.version;
                softwareVersionFilterList.push(sw);
            });
        }
    });

    let res: GetConfigurationTemplateReqData = {
        queryLimit: req.queryLimit,
        offset: req.offset,
        orderBy: req.orderBy,
        orderByDescending: req.orderByDescending,
        softwareVersionFilterList: softwareVersionFilterList,
    };

    return res;
}
